// extracted by mini-css-extract-plugin
module.exports = {"loginWallButton":"login-wall_loginWallButton__nHqBn"};